<template><service-agents /></template>
<script>
import ServiceAgents from './agents.vue'
// Keep bookmarked binding routes usable after consolidation.
export default { name: 'DkMallCustomerService', components: { ServiceAgents } }
</script>
